import moment from 'moment';

export const remainingDays = (value) => {
    let date1 = moment();
    let date2 = moment(new Date(value));
    let daysReamaining = date2.diff( date1, "days" );
    return daysReamaining;
  };